module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Copyright")])])]), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_vm._v("\n\tCopyright")]), _vm._v(" "), _c('div', {
    staticClass: "halftitle"
  }, [_c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tDiversion Books")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tA Division of Diversion Publishing Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\t443 Park Avenue South, Suite 1004")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tNew York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tCopyright © 1997 by Jane Bonander")])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tAll rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tFor more information, email "), _c('a', {
    attrs: {
      "href": "http://info@diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("info@diversionbooks.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tFirst Diversion Books edition May 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tISBN: 9781626810341")])])]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('p', {
    staticClass: "first",
    staticStyle: {
      "padding-top": "20%",
      "font-size": "1.1em",
      "text-align": "justify"
    }
  }, [_c('em', [_vm._v("For two of my favorite small-dog lovers, Evelyn Bonander and Donna King, and for Dorothy Lohman, whose Shih Tzu, Tashi, taught me everything I needed to know about the breed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "first",
    staticStyle: {
      "padding-top": "20%"
    }
  }, [_vm._v("\n\t\t\tLet those love now who never loved before;")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\t\tLet those who always loved, now love the more.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("\n\t\t\t—Thomas Parnell")])])]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('p', {
    staticClass: "first",
    staticStyle: {
      "padding-top": "20%",
      "font-size": "1.1em"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "text-indent": "1.5em",
      "font-size": "1em",
      "line-height": "1.4"
    }
  }, [_vm._v("A special ")])]), _c('em', [_c('span', {
    staticStyle: {
      "text-indent": "1.5em",
      "font-size": "1em",
      "line-height": "1.4"
    }
  }, [_vm._v("thank-you")])]), _c('em', [_c('span', {
    staticStyle: {
      "text-indent": "1.5em",
      "font-size": "1em",
      "line-height": "1.4"
    }
  }, [_vm._v(" to my Michigan friends, Nancy Giggey and Peggy Wang, for their unwavering support and for the title of this book.")])])])]), _vm._v(" "), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c183dee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap134654.vue
// module id = 63
// module chunks = 0